import React from 'react'
import useNationality from 'Hooks/useNationality'
import { CustomDropdownSelector } from './CustomDropdownSelector'

export const Nationalities = ({ formik }) => {
  const { data = [] } = useNationality()

  // Extraer el valor directamente desde Formik
  const selectedValue =
    data.find(
      item =>
        item.NationalityId.toUpperCase() ===
        formik.values.nationalityId?.toUpperCase()
    ) || null

  return (
    <CustomDropdownSelector
      label="Nacionalidad"
      value={selectedValue}
      options={data}
      onSelect={item => {
        formik.setFieldValue('nationalityId', item.NationalityId)
      }}
      getOptionLabel={item => item.Description}
      getOptionValue={item => item.NationalityId}
      error={
        formik.touched.nationalityId && formik.errors.nationalityId
          ? formik.errors.nationalityId.toString()
          : ''
      }
    />
  )
}
